import { render, staticRenderFns } from "./ArticleRating.vue?vue&type=template&id=3f1a7445&"
import script from "./ArticleRating.vue?vue&type=script&lang=js&"
export * from "./ArticleRating.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRating.vue?vue&type=style&index=0&id=3f1a7445&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports